const module = 'WorkStation';

const defaultOptions = {
  page: 1,
  sort: [
    {
      attribute: 'name',
      order: 'ASC'
    }
  ],
  condition: null
};

const allAssetsId = '4001';

const pageSize = 50;

const assetDetailsTab = 'ASSET_DETAILS';

const INTEGRATIONS = ['TEAM_VIEWER', 'SPLASH_TOP', 'CONNECT_WISE_CONTROL'];
const INTEGRATIONS_NON_SOLO = [
  'TEAM_VIEWER',
  'SUPEROPS_SPLASH_TOP',
  'CONNECT_WISE_CONTROL',
  'ISL'
];

const disableUnselectColumn = ['name'];

export {
  module,
  defaultOptions,
  allAssetsId,
  pageSize,
  assetDetailsTab,
  INTEGRATIONS,
  disableUnselectColumn,
  INTEGRATIONS_NON_SOLO
};
